import { render, staticRenderFns } from "./HoblTabs.vue?vue&type=template&id=4985bcb0&scoped=true"
import script from "./HoblTabs.vue?vue&type=script&lang=js"
export * from "./HoblTabs.vue?vue&type=script&lang=js"
import style0 from "./HoblTabs.vue?vue&type=style&index=0&id=4985bcb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985bcb0",
  null
  
)

export default component.exports